import React from 'react';
import '../styles/ErrorModal.css';

const ErrorModal = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="error-modal-overlay">
      <div className="error-modal-container">
        <div className="error-modal-header">
          <h2>{title}</h2>
        </div>
        <div className="error-modal-body">
          <div className="error-icon">✕</div>
          <p>{message}</p>
        </div>
        <div className="error-modal-footer">
          <button className="btn-ok" onClick={onClose}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
